const dollarsToCents = (dollars) => {
  const num = Number(dollars) || 0;
  return Math.round(num * 100);
};

const centsToDollars = (cents) => {
  const num = Number(cents) || 0;
  return num / 100;
};

const formatDollars = (dollars) => {
  const num = Number(dollars) || 0;
  return num.toLocaleString("en-US", { style: "currency", currency: "USD" });
};

const money = {
  dollarsToCents,
  centsToDollars,
  formatDollars,
};

export default money;
